import { render, staticRenderFns } from "./create-label.vue?vue&type=template&id=6181fd6e&scoped=true&"
import script from "./create-label.vue?vue&type=script&lang=ts&"
export * from "./create-label.vue?vue&type=script&lang=ts&"
import style0 from "./create-label.vue?vue&type=style&index=0&id=6181fd6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6181fd6e",
  null
  
)

export default component.exports